import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import * as types from '../actions/types';
import { attachOperationProp } from './utils';
import { fetchManagedSoundcastEpisodes } from './soundcast';

const commonPayloadCreators = {
  FAILURE: (payload, error) => ({ ...payload, error: error.message }),
};

export const fetchPublisherPlanUsage = createRoutine(types.FETCH_PUBLISHER_PLAN_USAGE, {
  ...commonPayloadCreators,
  TRIGGER: attachOperationProp('fetch-plan-usage'),
});

export const updateTagAsFeatured = createRoutine(types.UPDATE_FEATURED_CATEGORY, {
  ...commonPayloadCreators,
  TRIGGER: attachOperationProp('update-tag-as-featured'),
});
export const clearTagAsFeatured = createRoutine(types.CLEAR_FEATURED_CATEGORY, {
  ...commonPayloadCreators,
  TRIGGER: attachOperationProp('clear-tag-as-featured'),
});

export const updateTagAsFeaturedCreator = promisifyRoutine(updateTagAsFeatured);
export const clearTagAsFeaturedCreator = promisifyRoutine(clearTagAsFeatured);
export const fetchPublisherPlanUsageCreator = promisifyRoutine(fetchPublisherPlanUsage);
